import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import * as React from 'react';
import { DhlButton } from '@dhl-official/react-library';

export interface ConfirmationOptions {
  catchOnCancel?: boolean;
  variant?: 'danger' | 'info' | 'confirm';
  title?: string;
  description?: string | any;
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean;
  onSubmit: () => void;
  onClose: () => void;
}

// TODO move this common library copied from MMM (and slighlty edited)
export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  description,
  onSubmit,
  onClose,
  catchOnCancel,
}) => {
  return (
    <Dialog open={open}>
      <DialogTitle id='alert-dialog-title'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        {variant === 'danger' && (
          <>
            <DhlButton color='primary' variant='outline' onClick={onSubmit} data-testid='confirmDialogYesBtn'>
              Yes
            </DhlButton>
            <DhlButton color='primary' variant='outline' onClick={onClose} autoFocus data-testid='confirmDialogNoBtn'>
              No
            </DhlButton>
          </>
        )}

        {variant === 'confirm' && (
          <>
            <DhlButton color='primary' onClick={onSubmit}>
              Ok
            </DhlButton>
            <DhlButton color='primary' variant='outline' onClick={onClose} autoFocus>
              Cancel
            </DhlButton>
          </>
        )}

        {variant === 'info' && (
          <Button color='primary' onClick={onSubmit}>
            OK
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};
